module.exports = __webpack_public_path__ + "static/media/m_beard_stubble_oval_brown.1213972e.png";